import {getWorkflows, triggerWorkflow} from 'widget/api/workflows';

// Assuming SET_WORKFLOW is a constant, import it correctly
import { SET_WORKFLOW } from '../types';

export const state = {
  records: [],
};

export const getters = {
  getWorkflows(state) {
    return state.records;
  },
};

export const actions = {
  async get({ commit }, { websiteToken }) {
    try {

      const response = await getWorkflows(websiteToken);
      // Use the constant for the mutation type
      commit(SET_WORKFLOW, response.data);
    } catch (error) {
      console.error("Error in getWorkflows action:", error);
      // Handle the error appropriately
    }
  },

  async trigger({ commit }, { websiteToken, workflowId }) {
    try {

      const response = await triggerWorkflow(websiteToken, workflowId);
      // Use the constant for the mutation type

    } catch (error) {
      console.error("Error in triggerWorkflow action:", error);
      // Handle the error appropriately
    }
  },
};

export const mutations = {
  [SET_WORKFLOW](state, data) {

    state.records = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
